import dayjs from "dayjs";
export function getAgeFromDOB(dob) {
    return dayjs().diff(dob, "year") || "";
}
